import { Navigate } from 'react-router-dom';
import { isTenantDomain } from '@/utils/tenantDomain';

interface AdminOnlyRouteProps {
  children: React.ReactNode;
}

/**
 * Route wrapper that ensures the route is only accessible on the public domain.
 * Redirects to tenant login if accessed on a tenant subdomain.
 */
const AdminOnlyRoute: React.FC<AdminOnlyRouteProps> = ({ children }) => {
  // If on a tenant subdomain, redirect to tenant login
  if (isTenantDomain()) {
    return <Navigate to="/login" replace />;
  }

  // On public domain - render the route
  return <>{children}</>;
};

export default AdminOnlyRoute;
